<template>
    <div class="footer-container">
        <el-row class="footer-content" type="flex" justify="start">
            <el-col :md="{ span: 3, offset: 1 }" :lg="{ span: 4, offset: 3 }">
                <div class="footer-item ">
                    <div class="footer-title">Address</div>
                    <div class="footer-items">
                        <div>Tradehub 21, 18 Boon Lay Way</div>
                        <div>#03-138 (East Lobby)</div>
                        <div>Singapore 609966</div>
                    </div>
                </div>
            </el-col>

            <el-col :xs="{ span: 3, offset: 1 }" :lg="{ span: 4, offset: 3 }">
                <div class="footer-item ">
                    <div class="footer-title">Contact Us</div>
                    <div class="footer-items">
                        <div>Email: info@eazable.com</div>
                        <div>Phone: +65 6266 0300</div>
                        <div>Fax: +65 6665 0969</div>
                    </div>
                </div>
            </el-col>

            <el-col :xs="{ span: 5, offset: 1 }" :lg="{ span: 4, offset: 3 }">
                <div class="footer-right">
                    <div class="footer-title">Find Us on Social</div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: 'FooterBar'
    }
</script>

<style scoped>
    .footer-title {
        font-size: 23px;
    }

    .footer-items {
        font-size: 18px;
        margin-top: 3%;
    }

    .footer-container {
        background: #4d4d4d;
        color: #ffffff;
        padding-bottom: 3%;
        z-index: 1;
    }

    .footer-content {
        padding-top: 3%;
    }
</style>
